import image1 from "@assets/images/recommend/weddinghall/start1.png";
import image2 from "@assets/images/recommend/weddinghall/start2.png";
import image3 from "@assets/images/recommend/weddinghall/start3.png";
import image4 from "@assets/images/recommend/weddinghall/start4.png";

import styles from "./startRollingImage.module.scss";


const StartRollingImage = () => {
  return (
    <div className={styles.loop_banner_wrap}>
          <ul className={`${styles.banner_list} ${styles.n1}`}>
            <li className={styles.banner}>
              <img src={image1} alt="img_1" />
            </li>
            <li className={styles.banner}>
              <img src={image2} alt="img_1" />
            </li>
            <li className={styles.banner}>
              <img src={image3} alt="img_1" />
            </li>
            <li className={styles.banner}>
              <img src={image4} alt="img_1" />
            </li>
          </ul>
          <ul className={`${styles.banner_list} ${styles.n2}`}>
            <li className={styles.banner}>
              <img src={image1} alt="img_1" />
            </li>
            <li className={styles.banner}>
              <img src={image2} alt="img_1" />
            </li>
            <li className={styles.banner}>
              <img src={image3} alt="img_1" />
            </li>
            <li className={styles.banner}>
              <img src={image4} alt="img_1" />
            </li>
          </ul>
        </div>
  );
};

export default StartRollingImage;